import React from 'react'

import PropTypes from 'prop-types'

import { NOOP } from 'Utils/stableDefaults'

import Icon from './Icon/Icon'
import Tooltip from './Tooltip'

function InputWithPostfix({
  label = null,
  labelInfo = null,
  id,
  value = '',
  name = '',
  onChange,
  onBlur = NOOP,
  showError = false,
  errorText = null,
  type = 'text',
  required = false,
  disabled = false,
  formClassName = '',
  inputClassName = '',
  placeholder = '',
  postfix,
  simpleError = false,
  customContent = '',
  customLabelInfo = null,
}) {
  const inputErrorClass = showError && errorText ? 'is-invalid' : ''

  return (
    <div className={`form-group ${formClassName}`}>
      {label && (
        <label htmlFor={id}>
          {label}
          {required && <b> *</b>}
          {labelInfo && (
            <Tooltip id={`label-info-${id}`} content={labelInfo}>
              <Icon type={['fas', 'question-circle']} color="grey" className="info-icon ml-5" />
            </Tooltip>
          )}
          {customLabelInfo}
        </label>
      )}
      <div className="form-group--with-postfix">

        <input
          className={`form-control ${inputClassName} ${inputErrorClass}`}
          id={id}
          type={type}
          name={name}
          value={value}
          disabled={disabled}
          onChange={onChange}
          onBlur={onBlur}
          placeholder={placeholder}
        />
        <div className="form-group-append">
          <span className={`form-group-text ${inputErrorClass}`}>{postfix}</span>
        </div>
      </div>

      {customContent !== '' && (
        <small className="text-default">{customContent}</small>
      )}

      {showError
        && <div className={simpleError ? 'error-message' : 'error-message--tooltip tooltip--top'}>{errorText}</div>
      }
    </div>
  )
}

InputWithPostfix.propTypes = {
  label: PropTypes.string,
  labelInfo: PropTypes.string,
  id: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
  name: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  onBlur: PropTypes.func,
  showError: PropTypes.bool,
  errorText: PropTypes.string,
  type: PropTypes.string,
  required: PropTypes.bool,
  disabled: PropTypes.bool,
  formClassName: PropTypes.string,
  inputClassName: PropTypes.string,
  placeholder: PropTypes.string,
  postfix: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object,
  ]).isRequired,
  simpleError: PropTypes.bool,
  customContent: PropTypes.string,
  customLabelInfo: PropTypes.node,
}

export default InputWithPostfix
